// The icon a listing names (a Phosphor icon in kebab-case), from the few the catalogue uses.
import {
  type IconProps,
  Bug,
  ChatsCircle,
  GitPullRequest,
  type Icon,
  Lifebuoy,
  LockKey,
  Package,
  ShieldCheck,
  Siren,
  TreeStructure,
  UserCheck,
  UserList,
  Warning,
} from "@phosphor-icons/react";
import { createElement } from "react";

const ICONS: Record<string, Icon> = {
  "git-pull-request": GitPullRequest,
  bug: Bug,
  warning: Warning,
  "shield-check": ShieldCheck,
  "lock-key": LockKey,
  package: Package,
  "user-list": UserList,
  "user-check": UserCheck,
  siren: Siren,
  users: UserList,
  lifebuoy: Lifebuoy,
  "chats-circle": ChatsCircle,
  chat: ChatsCircle,
  "tree-structure": TreeStructure,
};

/** The listing's icon, or the workflow tree when it names one we don't carry. */
export function WorkflowIcon({ icon, ...props }: IconProps & { icon: string | null | undefined }) {
  return createElement((icon && ICONS[icon]) || TreeStructure, props);
}
